import { axios } from '@Root/API'

export const getStudentCourseSession = payload => {
	return axios.get(`student-engagement/${payload}`)
}
